<template>
  <div class="plan">
    <!-- <condition /> -->
    <course :editable=editable />
    <plan-price />
    <control :planId="id" />
  </div>
</template>

<script>
// import Condition from '../components/organisms/Condition'
import Course from '../components/organisms/Course'
import Control from '../components/organisms/Control'
import PlanPrice from '../components/organisms/PlanPrice'

export default {
  components: {
    // Condition,
    Course,
    Control,
    PlanPrice
  },
  data () {
    return {
      id: this.$route.params.id,
      editable: true
    }
  },
  created () {
    if (!this.$route.params.fromMap) {
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('favorites/fetchAll')
      this.$store.dispatch('places/fetchAll')
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
      this.$store.dispatch('loading/beginLoading')
      this.$store.dispatch('plans/fetchPlan', this.id)
        .finally(() => {
          this.$store.dispatch('loading/endLoading')
        })
    }
  }
}
</script>
